import React from 'react';


const CustomerService = () => (
  <div className="content">
    <div className="container">
      <p className="h2">NakedNews.com</p>
      <p className="h4">Third-Party Processors</p>

      <p> Name: Google, Inc.
        <br /> Address: 2300 Traverwood Dr. Ann Arbor, MI 48105 United States
        <br /> URL: https://www.google.com/analytics
        <br /> Type of data: Technical Data
        <br /> Purpose of processing: analytics
        <br /> Legal basis: consent</p>

      <p> Name: Content.ad
        <br /> Address: 400 Exchange, STE 250 Irvine, CA 92602
        <br /> URL: https://content.ad/
        <br /> Type of data: Technical Data
        <br /> Purpose of processing: track user interactions with advertisements
        <br /> Legal basis: consent</p>

      <p> Name: AdSterra (Ad Market LTD)
        <br /> Address: 15 Agiou Pavlou Str, Ledra House, Agios Andreas, 1105, Nicosia, Cyprus
        <br /> URL: https://adsterra.com
        <br /> Type of data: Technical Data
        <br /> Purpose of processing: pixel tracking
        <br /> Legal basis: consent</p>

      <p> Name: The Rocket Science Group, LLC d/b/a MailChimp
        <br /> URL: https://mailchimp.com
        <br /> Address: 675 Ponce de Leon Ave NE Suite 5000, Atlanta, GA 30308 USA
        <br /> Type of data: Identity Data
        <br /> Purpose of processing: to send email messages on our behalf
        <br /> Legal Basis: consent
      </p>
      <p className="h4">Billing Processors</p>
      <p> Name: RocketGate PR, LLC
        <br /> Address: 425 Carr. 693, PMB 260 Dorado, PR 00646
        <br /> URL: https://www.rocketgate.com/
        <br /> Type of data: Technical Data, Financial Data, Identity Data
        <br /> Purpose of processing: payment processing
        <br /> Legal basis: consent</p>

      <p> Name: Chief Products, LLC d/b/a Bill1st
        <br /> Address: 1515 N Federal Hwy #300, Boca Raton, FL 33432
        <br /> URL: https://www.bill1st.com/
        <br /> Type of data: Technical Data, Financial Data, Identity Data
        <br /> Purpose of processing: payment processing
        <br /> Legal basis: consent</p>

      <p> Name: PaySafe Holdings UK Ltd. (formerly Optimal Payments)
        <br /> Address: 27-25 Canada Square, 27th Floor London E14 5LQ United Kingdom
        <br /> URL: https://www.paysafe.com/
        <br /> Type of data: Technical Data, Financial Data, Identity Data
        <br /> Purpose of processing: payment processing
        <br /> Legal basis: consent</p>

      <p> Name: Epoch.com, LLC
        <br /> Address: 2644 30th St., 2nd floor Santa Monica, CA, 90405
        <br /> URL: https://www.epoch.com/
        <br /> Type of data: Technical Data, Financial Data, Identity Data
        <br /> Purpose of processing: payment processing
        <br /> Legal basis: consent</p>

      <p> Name: CCbill, LLC
        <br /> Address: 2353 W. University Dr. Tempe, AZ 85281-7223
        <br /> URL: https://www.ccbill.com/
        <br /> Type of data: Technical Data, Financial Data, Identity Data
        <br /> Purpose of processing: payment processing
        <br /> Legal basis: consent</p>

      <p> Name: 2000Charge, Inc.
        <br /> Address: 530 S Lake Ave # 303, Pasadena, CA 91101
        <br /> URL: https://www.2000charge.com
        <br /> Type of data: Technical Data, Financial Data, Identity Data
        <br /> Purpose of processing: payment processing
        <br /> Legal basis: consent
      </p>

      <p> Name: WTS / RCP Billing, LLC
        <br />Address: 7004 Bee Cave Road, Bldg 3, Ste 310 Austin, Texas 78746
        <br />URL: http://www.achdebit.com/index.php
        <br />Type of data: Technical Data, Financial Data, Identity Data
        <br />Purpose of processing: payment processing
        <br />Legal basis: consent
      </p>

      <p> Name: TLE Opportunities LLC
        <br />Address: 3840 East Robinson Road, Suite #418, Amherst, NY, US, 14120
        <br />URL: https://tleopportunities.com
        <br />Type of data: Technical Data, Financial Data, Identity Data
        <br />Purpose of processing: payment processing
        <br />Legal basis: consent
      </p>

    </div>
  </div>
);

export default CustomerService;
